<template>
  <div>
    <v-app-bar
      color="white"
      flat
      dark
      :class="$route.name == 'Home' ? 'hidden-sm-and-up' : 'hidden-md-and-up'"
      height="130px"
    >
      <v-layout wrap justify-space-between>
        <v-flex xs12 align-self-start>
          <Notification />
        </v-flex>
        <v-flex xs7 sm4 align-self-center pl-2>
          <v-layout wrap>
            <v-flex xs6 align-self-center>
              <router-link to="/">
                <v-img src="./../../assets/nellilogo.png" height="90px" contain />
              </router-link>
            </v-flex>
            <!-- <v-flex xs3 align-self-center>
              <router-link to="/">
                <v-img
                  src="./../../assets/images/logoP.png"
                  :height="$vuetify.breakpoint.name=='sm'?'45px':'35px'"
                  contain
                />
              </router-link>
            </v-flex> -->
          </v-layout>
        </v-flex>
        <v-flex xs2 text-right pr-2 align-self-center> 
          <v-app-bar-nav-icon style="color:black"
            v-on:click="navDrawer = !navDrawer"
          ></v-app-bar-nav-icon>
        </v-flex>
      </v-layout>
    </v-app-bar>
    <v-navigation-drawer
      v-model="navDrawer"
      color="#000"
      dark
      clipped
      temporary
      right
      fixed
    >
      <v-layout wrap v-for="(item, i) in navItems" :key="i">
        <v-flex xs12>
          <v-btn block text :to="item.route">
            <span class="navItem">
              {{ item.name }}
            </span>
          </v-btn>
        </v-flex>
        <v-flex xs12>
          <v-divider></v-divider>
        </v-flex>
      </v-layout>
    </v-navigation-drawer>
  </div>
</template>
<script>
import Notification from "./notification";
export default {
  components: {
    Notification,
  },
  data() {
    return {
      navDrawer: false,
      navItems: [
        { name: "About", route: "/about", type: "link" },
        {
          name: "Eco Tourism",
          route: "/ecoTourism",
          type: "link",
        },
        { name: "Media", route: "/media", type: "link" },
        { name: "Contact Us", route: "/contact", type: "link" },
      ],
    };
  },
};
</script>
<style>
.navItem {
  font-family: sofiaProLight;
  font-size: 14px;
  text-transform: none;
  letter-spacing: 3px;
}
</style>